<template>
<div class="section footer-padding">
  <div class="settings-container">
    <div class="box settings-box">
      <b-field label="Enable notifications" horizontal>
        <b-checkbox v-model="notifications_enabled"/>
      </b-field>

      <b-field label="Hide yourself from searches" horizontal>
        <b-checkbox v-model="hidden"/>
      </b-field>

      <b-field label="Change password" horizontal>
        <b-input type="password" v-model="password" password-reveal
          placeholder="fill in a new password to change it"/>
      </b-field>
      <b-field label="Confirm password" horizontal>
        <b-input type="password" v-model="password_repeat" password-reveal
          placeholder="Match the password above"/>
      </b-field>
    </div>
  </div>


  <Footer>
    <button :class="[
      'button', 'is-medium',
      'is-primary', loading && 'is-loading']"
      @click="save">
      Save
    </button>
  </Footer>
</div>
</template>

<script>
import Footer from '@/components/Footer';
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      notifications_enabled: null,
      password: null,
      password_repeat: null,
      hidden: null,
      loading: false,
    };
  },
  components: {
    Footer,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    ...mapMutations({
      setUser: 'auth/setUser',
    }),
    async save() {
      if ((this.password || this.password_repeat) && this.password !== this.password_repeat) {
        this.$toast.open({
          message: 'Passwords do not match',
          type: 'is-danger',
        });
        return;
      }
      this.loading = true;
      const payload = {
        notifications_enabled: this.notifications_enabled,
        hidden: this.hidden,
      };
      if (this.password) {
        payload.password = this.password;
      }
      try {
        this.setUser((await this.$http.patch('/users/self/', payload)).data);
        this.$toast.open({
          message: 'Success',
          type: 'is-success',
        });
      } catch (e) {
        this.$toast.open({
          message: 'Could not apply settings',
          type: 'is-danger',
        });
      }
      this.initialize();
      this.loading = false;
    },
    initialize() {
      this.hidden = this.user.hidden;
      this.notifications_enabled = this.user.notifications_enabled;
      this.password = null;
      this.password_repeat = null;
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
.settings-container {
  display: flex;
  justify-content: center;
}

/deep/ .field-label {
  flex-grow: 3
}
</style>
